import axios from 'axios';
import Cookies from 'js-cookie';
import { getAuthHeader } from './userInfo-actions';

const jwtCookie = Cookies.get(
  `${process.env.REACT_APP_API_COOKIE_CONSTANT}`
);

export const getAwsCredentials = async (
  academy,
  file,
  fileType,
  archive
) => {
  let credentials = await axios.get(
    `${process.env.REACT_APP_API_PATH_MAYAHII}/catalogos/profile_edit_photocatalogos/profile_edit_photo`,
    {
      params: { academy },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (credentials.data) {
    const signedUrl = 'https://d2umnppmqt7ext.cloudfront.net/';
    const options = {
      headers: {
        'Content-Type': fileType,
        Accept: '*/*'
      }
    };
    const key = `${credentials.data.username}/profile/${file}`;
    let data = new FormData();
    data.append('name', file);
    data.append('key', key);
    data.append('Filename', key);
    data.append('AWSAccessKeyId', `${credentials.data.accessKey}`);
    data.append('acl', 'public-read');
    data.append('policy', `${credentials.data.policy}`);
    data.append('signature', `${credentials.data.signature}`);
    data.append('Content-Type', fileType);
    data.append('success_action_status', '201');
    data.append('file', archive);
    const request = await axios.post(signedUrl, data, options);
    if (request.statusText === 'Created') {
      return `https://d2umnppmqt7ext.cloudfront.net/${credentials.data.username}/profile/${file}`;
    }
  }
  return false;
};

export const saveSettings = async body => {
  const save = await axios.post(
    `${process.env.REACT_APP_API_PATH_USER}/user/profile`,
    body,
    { headers: getAuthHeader(jwtCookie) }
  );
  if (save.data.updated) {
    return true;
  }
  return false;
};

export const checkPassword = async password => {
  const confirm = await axios.post(
    `${process.env.REACT_APP_API_PATH_USERINFO}/user/password-validation`,
    {
      password
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (confirm.data) {
    return true;
  }
  return false;
};

export const setChangePassword = async (
  passPrev,
  passNew,
  passConf
) => {
  let confirmPassword = await axios.get(
    `${process.env.REACT_APP_API_PATH_MAYAHII}/miMayahii/edit_password`,
    {
      params: { passPrev, passNew, passConf },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (confirmPassword.data) {
    return true;
  }
  return false;
};

export const getUserMetadata = async () => {
  let metadata = await axios.get(
    `${process.env.REACT_APP_API_PATH_USER}/user/metadata`,
    {
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (metadata.data.userMetadata.length > 0) {
    return metadata.data.userMetadata;
  } else {
    return [];
  }
};

export function getAllMetadata() {
  const request = axios.get(
    `${process.env.API_PATH_USER}/user/metadata`,
    { headers: getAuthHeader() }
  );
  return {
    type: 'GET_ALL_METADATA',
    payload: request
  };
}

export const saveNewMetaData = async editMetaDataObject => {
  const confirm = await axios.post(
    `${process.env.REACT_APP_API_PATH_USERINFO}/metadata/save-metadata`,
    editMetaDataObject,
    { headers: getAuthHeader(jwtCookie) }
  );
  if (confirm.data.result) {
    return true;
  }
  return false;
};
